import { apiGet, apiSend, USE_MOCK_API, API_BASE_URL } from './httpClient'

export interface ConnectedAccount {
  provider: string
  connected: boolean
  email: string | null
  connected_at: string | null
}

export interface GmailMessage {
  message_id: string
  subject: string
  from: string
  date: string
  snippet: string
  processed: boolean
}

export interface ExtractedEmail {
  type: string
  title: string
  date: string | null
  time: string | null
  location: string
  confirmation_number: string
  price: number | null
  currency: string
  check_in: string | null
  check_out: string | null
  airline: string | null
  flight_number: string | null
  origin: string | null
  destination: string | null
}

export interface ImportedPoint {
  id: string
  title: string
  type: string
}

export async function getConnectedAccounts(): Promise<ConnectedAccount[]> {
  if (USE_MOCK_API) {
    return [{ provider: 'google', connected: false, email: null, connected_at: null }]
  }
  return apiGet<ConnectedAccount[]>('/auth/connected-accounts')
}

export function getGoogleConnectUrl(): string {
  if (USE_MOCK_API) return '#'
  return `${API_BASE_URL}/auth/connect/google`
}

export async function disconnectGoogle(): Promise<void> {
  if (USE_MOCK_API) return
  await fetch(`${API_BASE_URL}/auth/connect/google`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${localStorage.getItem('st:token')}` },
  })
}

export async function listGmailMessages(tripId: string): Promise<GmailMessage[]> {
  if (USE_MOCK_API) {
    return [
      {
        message_id: 'msg_demo_001',
        subject: 'Your flight to Rome — Order #ABC123',
        from: 'noreply@airline.com',
        date: '2026-07-01',
        snippet: 'Flight LY315 TLV→FCO departs 14:30. Confirmation: ABC123.',
        processed: false,
      },
      {
        message_id: 'msg_demo_002',
        subject: 'Hotel Colosseum — Booking Confirmation #BK9876',
        from: 'noreply@booking.com',
        date: '2026-07-01',
        snippet: 'Check-in: Aug 10 2026. Check-out: Aug 15 2026. Total: EUR 895.',
        processed: false,
      },
    ]
  }
  return apiGet<GmailMessage[]>(`/trips/${tripId}/import/gmail/messages`)
}

export async function importGmailMessages(
  tripId: string,
  messageIds: string[],
): Promise<ImportedPoint[]> {
  if (USE_MOCK_API) {
    return messageIds.map((id, i) => ({
      id: `point_${id}`,
      title: i === 0 ? 'Flight to Rome' : 'Hotel Colosseum',
      type: i === 0 ? 'airport' : 'hotel',
    }))
  }
  return apiSend<ImportedPoint[]>('POST', `/trips/${tripId}/import/gmail`, { message_ids: messageIds })
}
